import { render } from "./GalleryItem.vue?vue&type=template&id=08f04a7c&scoped=true"
import script from "./GalleryItem.vue?vue&type=script&lang=js"
export * from "./GalleryItem.vue?vue&type=script&lang=js"

import "./GalleryItem.vue?vue&type=style&index=0&id=08f04a7c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08f04a7c"]])

export default __exports__